<template>
  <div class="fb fb-col fb-main-start font-34 border-171A1D">
    <div class="content item-flex-1">
      <div v-if="needTimeSelect">
        <common-date-section
          v-if="!dateType"
          passby
          @time-section="timeSection"
        ></common-date-section>
        <div
          v-else
          class="settingTime font-34 fb fb-main-between fb-cross-center"
          @click="chooseDate()"
        >
          <span>选择日期</span>
          <span class="c-191F25-28"
            ><span>{{ computeDate }}</span
            ><i class="iconfont c-191F25-28">&#xe601;</i></span
          >
        </div>
        <p v-if="exportTable" class="p-0-16 lh-34 c-191F25-40 font-26"
          >选择的时间范围最大不能超过{{ timeLimit }}天</p
        >
      </div>
      <common-select-input-box
        v-if="showBook"
        class="bg-FFFFFF p-0-16"
        :class="[!this.exportTable && needTimeSelect ? 'mt-8' : '']"
        label="选择班级"
        :label-width="190"
        :color="true"
        :value="(classData || []).length ? `${classData.length}部门` : ''"
        @click="handlerChooseClassList"
      ></common-select-input-box>
      <p v-if="exportTable" class="p-0-16 lh-34 c-191F25-40 font-26"
        >导出的数据将通过企业账号发送给你，请注意</p
      >
      <ul v-else class="fb fb-row fb-cross-center fb-wrap mt-10 p-0-8 pb-72">
        <li
          v-for="(item, index) in list"
          :key="index"
          class="bg-FFFFFF m-0-8 font-26 p-0-8 p-4-0 fb fb-cross-center fb-main-center show-class"
          @click="handlerClass(item, index)"
          :class="[index === selectedIndex ? 'bgColor c-006AFE' : '']"
        >
          <span class="ellipsis-l2 item-self-center">{{ item.name }}</span>
        </li>
      </ul>
      <div class="footer fb fb-main-center fb-cross-center foot">
        <common-button @click="handlerToSaveFilterCondition">{{
          exportTable ? '导出报表' : '确认'
        }}</common-button>
      </div>
    </div>
  </div>
</template>

<script>
import commonButton from './commonButton'
import commonDateSection from './commonDateSection'
import commonSelectInputBox from './commonSelectInputBox'
import { mcDatePicker, mcToast } from '@/utils/mcSdkUtils'
import { timeFormat, getItem, mergeJsonById } from '@/utils/comUtils'
import mixin from '@/mixin'
import { RETURN_TYPE, LEAVE_ROLE, TAB_ROLE_ID } from '@/utils/constUtils'

export default {
  components: {
    commonButton,
    commonSelectInputBox,
    commonDateSection
  },
  props: {
    needBook: {
      type: Boolean,
      default: false
    },
    curRole: {
      type: Number,
      default: 0
    },
    // 是否需要时间选择组件
    needTimeSelect: {
      type: Boolean,
      default: true
    },
    // 时间选择组件日期范围限制
    timeLimit: {
      type: Number,
      default: 0
    },
    // 是否为导出
    exportTable: {
      type: Boolean,
      default: false
    },
    // 日期组件类型
    dateType: {
      type: Number,
      default: 0
    },
    // 选人组件返回类型
    selectType: {
      type: Number | String,
      default: 3 // 班级
    },
    endType: {
      type: Number | String,
      default: 3 // 班级
    },
    // 选人组件返回类型
    returnType: {
      type: String | Number,
      default: RETURN_TYPE.id
    },
    // 是否支持多选
    multiple: {
      type: Boolean,
      default: true
    }
  },
  mixins: [mixin],
  data() {
    return {
      classData: [],
      startTime: '',
      endTime: '',
      timePass: false,
      selectedIndex: -1,
      list: [],
      singleDate: '', // 单选日期默认
      headerTabId: 0
    }
  },
  computed: {
    computeDate() {
      if (this.singleDate) {
        return this.singleDate
      }
      let _date = new Date()
      return timeFormat(_date)
    },
    // 当前显示的是否为自定义界面
    isAdminPage() {
      return [LEAVE_ROLE.admin, LEAVE_ROLE.customRole].includes(
        +this.headerTabId
      )
    },
    // 当前显示的是否为班主任界面
    isHeadmasterPage() {
      return [LEAVE_ROLE.headmaster].includes(+this.headerTabId)
    },
    showBook() {
      // 如果当前是自定义角色又是班主任，优先显示班主任
      if (this.needBook || (this.curIsAdmin && this.isAdminPage)) {
        return true
      } else if (
        this.isAdminPage &&
        !this.curIsAdmin &&
        this.curIsCampusHeadmaster
      ) {
        return false
      } else if (
        this.isAdminPage &&
        (!this.curIsCampusHeadmaster || this.curIsAdmin)
      ) {
        return true
      } else if (this.isHeadmasterPage) {
        return false
      } else {
        return false
      }
    }
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    let { role } = getItem(TAB_ROLE_ID) || {}
    this.headerTabId = role
    this.init()
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    init() {
      if (!this.showBook) {
        let classData = mergeJsonById(
          this.teacherClassList,
          this.classList,
          'tpId'
        )
        classData.forEach(item => {
          let classInfo = {
            name: item.name,
            tpId: item.tpId,
            deptId: item.deptId
          }
          this.list.push(classInfo)
        })
      }
    },
    // 选择时间区间
    timeSection(start, end) {
      this.startTime = start
      this.endTime = end
      if (this.timeLimit) {
        let _start = +new Date(`${this.startTime.replace(/-/gi, '/')} 00:00`)
        let _end = new Date(`${this.endTime.replace(/-/gi, '/')} 00:00`)
        _end.setDate(_end.getDate() + 1)
        this.timePass = +_end - _start > this.timeLimit * 86400000
      }
    },
    handlerToSelecteDate(index) {
      const _defaultTime = this.filter[index === 0 ? 'startTime' : 'endTime']
      // eslint-disable-next-line
      const _compareTime = +this.filter[
        index === 0 ? 'endTime' : 'startTime'
      ].replace(/-/g, '')
      mcDatePicker({ date: _defaultTime, format: 'YYYY-MM-DD' })
        .then(({ date, picker } = {}) => {
          const dimDay = +date.replace(/-/g, '')
          if (
            _compareTime &&
            (index ? dimDay < _compareTime : dimDay > _compareTime)
          ) {
            picker.reset()
            return mcToast({ msg: '开始日期不能大于结束日期' })
          }

          this.filter[index === 0 ? 'startTime' : 'endTime'] = date
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
    },
    // 选择班级
    handlerChooseClassList() {
      let _mSchoolAddressBook = {
        addressType: 2,
        role: this.curRole || this.$store.getters.currentRole,
        userId: this.dingUserId,
        corpId: this.corpId,
        appId: this.appId,
        corpName: this.corpName,
        selectType: this.selectType,
        endType: this.endType,
        returnType: this.returnType, // 返回魔点Id
        classList: this.classData || [],
        multiple: this.multiple,
        campus: this.$store.getters.currentCapmus,
        canViewDetail: false
      }
      this.$addressList(_mSchoolAddressBook)
        .then(res => {
          if (!res) {
            return
          }
          let _single = null
          if (!this.multiple) {
            switch (this.returnType) {
              case 0:
                _single = res.deptId
                break
              case 1:
                _single = res.tpId
                break

              default:
                _single = res ? Object.assign({}, res) : _single
                break
            }
          }
          this.classData = this.multiple ? res.depts : _single ? [_single] : []
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
    },
    handlerClass(classObj, index) {
      this.selectedIndex = index
      this.classData = [classObj]
    },
    chooseDate() {
      mcDatePicker({ date: this.computeDate, format: 'YYYY-MM-DD' })
        .then(({ date } = {}) => {
          this.singleDate = date
        })
        .catch()
    },
    handlerToSaveFilterCondition() {
      if (this.timePass && this.timeLimit && !this.dateType) {
        mcToast({ msg: `时间范围不能超过${this.timeLimit}天` })
        return false
      }
      let _condiction = {
        startTime: this.startTime.replace(/-/gi, '/'),
        endTime: this.endTime.replace(/-/gi, '/'),
        classList: this.classData,
        singleDate: this.computeDate.replace(/-/gi, '/')
      }
      if (this.exportTable) {
        if (!this.classData.length) {
          mcToast({ msg: '选择需导出报表的班级' })
          return false
        }
        this.$emit('toExport', _condiction)
      } else {
        if (
          this.curIsCampusHeadmaster &&
          (!this.classData || !this.classData.length)
        ) {
          mcToast({ msg: '请选择班级' })
          return
        }
        this.$emit('toFilter', _condiction)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.foot {
  position: fixed;
  bottom: 0;
}
.settingTime {
  border-left: 16px solid transparent;
  height: 48px;
  background: #ffffff;
  border-left: 16px solid transparent;
  border-right: 16px solid transparent;
  border-bottom: 1px solid rgba(246, 246, 246, 1);
}
.show-class {
  box-sizing: border-box;
  height: 46px;
  width: calc(50% - 16px);
  text-align: center;
  margin-top: 14px;
  border: 1px solid rgba(17, 31, 44, 0.12);
  border-radius: 3px;
}

.bgColor {
  background: rgba(50, 150, 250, 0.17);
}
</style>
